export const BASE_URL = process.env.BASE_URL || 'https://008a-77-137-67-61.ngrok-free.app';